/**
 * @tabler/icons-react v2.47.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconMapHeart = createReactComponent("map-heart", "IconMapHeart", [
  ["path", { d: "M10 17.5l-1 -.5l-6 3v-13l6 -3l6 3l6 -3v7", key: "svg-0" }],
  ["path", { d: "M9 4v13", key: "svg-1" }],
  ["path", { d: "M15 7v4", key: "svg-2" }],
  [
    "path",
    {
      d: "M18 22l3.35 -3.284a2.143 2.143 0 0 0 .005 -3.071a2.242 2.242 0 0 0 -3.129 -.006l-.224 .22l-.223 -.22a2.242 2.242 0 0 0 -3.128 -.006a2.143 2.143 0 0 0 -.006 3.071l3.355 3.296z",
      key: "svg-3"
    }
  ]
]);

export { IconMapHeart as default };
//# sourceMappingURL=IconMapHeart.js.map
